import { Checkbox, FormControlLabel } from '@material-ui/core';
import { useField } from 'formik';
import * as React from 'react';

const CheckBoxFormik = ({ label, ...props }) => {
  const [fields] = useField(props);
  const { name } = props;

  return (
    <FormControlLabel
      control={
        // eslint-disable-next-line react/jsx-wrap-multilines
        <Checkbox
          inputProps={{
            name,
          }}
          color="primary"
          {...fields}
          {...props}
        />
      }
      label={label}
      {...props}
    />
  );
};

export default CheckBoxFormik;
